// Paths that considered as prizes pages
// This is used to determine if the bottom navigation should activate the prizes tab
const PromotionPaths = {
  PROMOTION_PLAY_AND_SPIN: "/play-and-spin",
  PROMOTION_REFER_BALLS: "/refer-balls",
  PROMOTION_CASHBACK: "/cashback",
  PROMOTION_DAILY_LOGIN: "/daily-reward",
  /**
   * @deprecated Use PROMOTION_SHARE_AND_EARN instead
   */
  PROMOTION_MEGA_SHARE: "/mega-share",
  PROMOTION_SHARE_AND_EARN: "/share-and-earn",
  PROMOTION_SECRET_CODE: "/secret-code",
  PROMOTION_REDEEM_SECRET_CODE: "/redeem-secret-code",
};

export const Paths = {
  PRIVATE: {
    HOME: "/",
    DEPOSIT: "/deposit",
    PROFILE: "/profile",
    CONTACT: "/contact",
    TRANSACTION: "/transaction",
    BANK_ACCOUNTS: "/bank-accounts",
    BANK_ACCOUNT: "/bank-account",
    BET_HISTORY: "/betting-history",
    LANGUAGE: "/language",
    UPDATE_BANK: "/update-bank",
    CHANGE_PASSWORD: "/change-password",
    TERMS_CONDITIONS: "/terms-and-conditions",
    DEPOSIT_CALLBACK: "/:provider/:orderRef/return",
    PRIZES: "/prizes",
    PERSONAL_INFO: "/personal-info",
    E_WALLETS: "/e-wallets",
    E_WALLET: "/e-wallet",
    CHANGE_PIN: "/change-pin",
    PLAY_AND_SPIN: "/play-and-spin",

    // promotion
    ...PromotionPaths,
    PROMOTION_REFER_FRIEND: "/referral",

    // auth post login steps
    AUTH_LEGAL_NAME_PAGE: "/auth/legal-name",
    AUTH_BANK_LEGAL_NAME_PAGE: "/auth/bank-legal-name",
    AUTH_BANK_ACCOUNT_PAGE: "/auth/bank-account",
    AUTH_RESET_PAGE: "/auth/reset",
  },
  PUBLIC: {
    // onboard dialog
    ONBOARD_DIALOG: "/onboard",
    ONBOARD_LOGIN_DIALOG: "/onboard/login",
    ONBOARD_REGISTER_DIALOG: "/onboard/register",
    // onboard full page
    ONBOARD_PAGE: "/login",
    ONBOARD_LOGIN_PAGE: "/login",
    ONBOARD_REGISTER_PAGE: "/register",
    // auth full page step
    AUTH_LOGIN_PAGE: "/auth/login",
    AUTH_REGISTER_PAGE: "/auth/register",
    AUTH_FORGOT_PAGE: "/auth/forgot",

    // misc
    MAINTENANCE: "/maintenance",
    REFERRAL_CALLBACK: "/r/:refCode",
    IFRAME_SHUTDOWN: "/iframe-shutdown",
  },
};

export const NOTIFICATION_DRAWER_ROUTES = [Paths.PRIVATE.PRIZES];

export const PRIZE_PAGES = new Set([Paths.PRIVATE.PRIZES, ...Object.values(PromotionPaths)]);

export const SHAREABLE_LANDING_PATHS = new Set<string>([
  Paths.PRIVATE.PRIZES,
  Paths.PRIVATE.PROMOTION_PLAY_AND_SPIN,
  Paths.PRIVATE.PROMOTION_CASHBACK,
  Paths.PRIVATE.PROMOTION_DAILY_LOGIN,
  Paths.PRIVATE.PROMOTION_REFER_FRIEND,
  Paths.PRIVATE.PROMOTION_REFER_BALLS,
  Paths.PRIVATE.PROMOTION_SHARE_AND_EARN,
]);

export const isShareableLandingPath = (path: string | null | undefined): path is string =>
  !!path && SHAREABLE_LANDING_PATHS.has(path);
